import { Component, Inject, OnDestroy } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { IConfirmData } from '@app/core/info/confirm/confirm';
import { Subject } from 'rxjs';

@Component({
  selector: 'cloud-confirm',
  templateUrl: './confirm.component.html',
  styleUrls: ['./confirm.component.scss']
})
export class ConfirmComponent implements OnDestroy {
  wait: boolean;
  unsubscribe$: Subject<void> = new Subject<void>();

  constructor(
    public dialogRef: MatDialogRef<ConfirmComponent>,
    @Inject(MAT_DIALOG_DATA) public data: IConfirmData
  ) {
  }

  /**
   * Компонентът, който извиква потвърждаващия диалог има отговорност да се погрижи за затварянето му
   */
  onConfirm() {
    this.wait = true;
    this.dialogRef.disableClose = true;
    this.data.confirmAction();
  }

  close(res: boolean): void {
    this.wait = false;
    this.dialogRef.close(res);
  }

  ngOnDestroy() {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }
}
